import { useEffect, useState } from "react";
import PieChart from "../../../Charts/PieChart";
import { httpGet } from "../../../../../modules/Backend";
import { HttpStatusCode } from "axios";
import LoadingButton from "../../../LoadingButton";
import { getFormattedTime } from "../../../../../helpers/DateHelper";

// Color mappings for base material types
const MATERIAL_TYPE_COLORS: Record<string, string> = {
    'Slide': '#FF8080',
    'Block': '#3BC1EC',
    'Document': '#85DF88',
    'Card': '#FDCA7E',
    'Other': '#9B59B6',
    'Mixed': '#95A5A6',
    'Unassigned': '#95A5A6',
};

export default function SidePanelOuterCubeMaterial({ data }: { data: any }) {
    const [values, setValues] = useState<Array<{ label: string; value: number; baseType?: string }>>()
    const [refreshing, setRefreshing] = useState(false);
    const [asOf, setAsOf] = useState<Date | undefined>();

    async function getStats(refreshData: boolean = false) {
        setRefreshing(true);
        const result = await httpGet(`api/outerCubes/materialTypeComposition?id=${data.id}&refreshData=${refreshData}`);
        if (result.status === HttpStatusCode.Ok) {
            setValues(result.data.stats);
            if (result.data.asOf) {
                setAsOf(new Date(result.data.asOf));
            }
        }
        setRefreshing(false);
    }

    useEffect(() => {
        if (data) {
            getStats(false);
        }
    }, [data])

    return (<>
        <div className="side-panel__info-box margin__top--s">
            <div className={`display--flex justifyContent--space-between ${values && values.length > 0 ? '' : 'alignItems--center'}`}>
                <div className={`pallet-stats__material-types-heading ${values && values.length > 0 ? '' : 'alignItems--center'}`}>
                    <p className="small">Material type composition</p>
                    {!values || values?.length === 0 && <span className="pallet-stats__as-of">(no types yet)</span>}
                </div>
                <div className={`pallet-stats__refresh-material-types`}>
                    <LoadingButton isDisabled={refreshing} isLoading={refreshing}
                        className="button button--secondary button--extra-small" onPress={() => getStats(true)}
                        loadingText="Refreshing"
                        buttonText="Refresh">
                        <></>
                    </LoadingButton>
                    {values && values.length > 0 && asOf && <p className="pallet-stats__as-of">As of: <span>{getFormattedTime(asOf)}</span></p>}
                </div>
            </div>
            {refreshing && <div className="loaders loaders__panel--small margin__top--xs"></div>}
            {!refreshing && values && values.length > 0 &&
                <div className="pallet-stats__material-types">
                    <PieChart data={values} colorMappings={MATERIAL_TYPE_COLORS} />
                </div>
            }
        </div>
    </>
    )
}